import {HttpClient} from '@angular/common/http';
import {Injectable, inject} from '@angular/core';
import {AgencyTag} from '../models/agency-tag';
import {Observable, map, shareReplay} from 'rxjs';
import {environment} from 'src/environments/environment';
import {WebApiResponse} from '../models/response';

@Injectable({providedIn: 'root'})
export class AgencyTagService {
  private httpClient = inject(HttpClient);

  private getAgencyTags = `getAgencyTags`;
  private agencyTagUrl = `${environment.apiURL}/agencytag`;

  public getAgencyTagList = (): Observable<AgencyTag[]> => {
    return this.httpClient
      .get<WebApiResponse<AgencyTag[]>>(
        `${this.agencyTagUrl}/${this.getAgencyTags}`
      )
      .pipe(
        map((response) => response.result),
        shareReplay(1)
      );
  };
}
